import { useEffect, useState } from 'react';

export const AppLoader = () => {
  const [message, setMessage] = useState('Loading...');

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setMessage('Still loading...');
    }, 4000);

    return () => {
      window.clearTimeout(timeout);
    };
  }, []);
  return (
    <div className="flex min-h-screen items-center justify-center bg-app-primary">
      <div className="text-app-primary-foreground">{message}</div>
    </div>
  );
};
